import axios from "../../axios";

const getIpAddress = async function (accessToken,adminId = {}) {
    try {
        const response = await axios.get('/admin/administration/getIpAddress' ,{
            headers: {
                'Authorization': accessToken
            },
            params: {
                admin_id: adminId
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getIpAddress;
